import { render, staticRenderFns } from "./shop-grids.vue?vue&type=template&id=57a7c767&"
import script from "./shop-grids.vue?vue&type=script&lang=js&"
export * from "./shop-grids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports